import { motion } from "framer-motion";
import { X, Building2 } from "lucide-react";

export const input = "w-full bg-white border border-navy/10 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm";
export const mxn = (v) => (v == null || v === "" ? "—" : Number(v).toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }));

export function GrHeader({ title, desc }) {
  return (
    <div>
      <div className="overline text-navy/40 mb-2 flex items-center gap-2"><Building2 className="w-3.5 h-3.5" /> GOÛT READY™ · Sales Suite</div>
      <h2 className="font-editorial text-4xl tracking-tight">{title}</h2>
      <p className="mt-2 text-navy/50 max-w-2xl">{desc}</p>
    </div>
  );
}

export function GrModal({ title, onClose, children, testid, wide }) {
  return (
    <div className="fixed inset-0 z-50 bg-navy/40 backdrop-blur-sm flex items-center justify-center p-4" data-testid={testid}>
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className={`card-surface w-full ${wide ? "max-w-lg" : "max-w-sm"} max-h-[90vh] overflow-y-auto p-6`}>
        <div className="flex items-center justify-between mb-4"><h3 className="font-editorial text-2xl">{title}</h3><button onClick={onClose}><X className="w-5 h-5 text-navy/40" /></button></div>
        {children}
      </motion.div>
    </div>
  );
}
